/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {DataServerConfig} from "../../api";
import {Injectable} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



type ApiCallbackFunc = (obj) => void;

@Injectable()
export class VisitorProfileResource {
  private readonly secVisitorUri = DataServerConfig.obtain().getUri('synchronous/visitor');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  getVisitor(folderId: string, browserId: string, cb: ApiCallbackFunc, errCb: ApiCallbackFunc, status) {
    status.isPending = true;
    return this.send({
      method: 'GET',
      url: this.secVisitorUri,
      params: {folderId: folderId, browserId: browserId}
    }).then(function(data) {
      status.isPending = false;
      return (cb || _.noop)(data);
    }).catch(function(response) {
      status.isPending = false;
      status.hasError = true;
      return (errCb || _.noop)(response);
    });
  }
}
